/**
 * Emergency Admin Login Setup
 * 
 * This script provides a fallback method to create and login as admin
 * when the normal authentication flow fails.
 */

import { AuthService } from '../services/auth';

export const emergencyAdminLogin = async (): Promise<{
  success: boolean;
  message: string;
  user?: any;
}> => {
  console.log('🚨 Emergency Admin Login - Starting...');
  
  try {
    // First, try to create the admin user
    console.log('📝 Creating admin user...');
    const createResult = await AuthService.createAdminUser(
      'admin@woteintercity.com',
      'admin123',
      'Admin',
      'User',
      '+233123456789',
      'super_admin'
    );
    
    if (createResult.success) {
      console.log('✅ Admin user created successfully');
      
      // Now try to sign in
      console.log('🔐 Attempting to sign in...');
      const signInResult = await AuthService.signIn('admin@woteintercity.com', 'admin123');
      
      if (signInResult.success) {
        console.log('✅ Successfully signed in as admin');
        return {
          success: true,
          message: 'Admin user created and signed in successfully',
          user: signInResult.user
        };
      } else {
        console.error('❌ Failed to sign in:', signInResult.error);
        return {
          success: false,
          message: `Admin user created but sign in failed: ${signInResult.error}`
        };
      }
    } else {
      // User might already exist, try to sign in
      console.log('👤 Admin user might already exist, trying to sign in...');
      const signInResult = await AuthService.signIn('admin@woteintercity.com', 'admin123');
      
      if (signInResult.success) {
        console.log('✅ Successfully signed in as existing admin');
        return {
          success: true,
          message: 'Signed in as existing admin user',
          user: signInResult.user
        };
      } else {
        console.error('❌ Failed to sign in to existing admin:', signInResult.error);
        return {
          success: false,
          message: `Failed to sign in: ${signInResult.error}`
        };
      }
    }
  } catch (error: any) {
    console.error('💥 Emergency admin login failed:', error);
    return {
      success: false,
      message: `Emergency login failed: ${error.message}`
    };
  }
};

// Make it available globally
if (typeof window !== 'undefined') {
  (window as any).emergencyAdminLogin = emergencyAdminLogin;
  console.log('🚨 Emergency admin login available as: emergencyAdminLogin()');
}

export default emergencyAdminLogin;
